import { sortBy } from 'lodash';

import {
  campaignService,
  infoService,
  userSettingsService,
  targetService,
  affiliateService,
  pingTreeTargetService,
  buyerService,
  userGroupService,
  callPlanService
} from '@/angularBridgeCode/ringbaPortal.servicesModule';

import {
  SET_TIMEZONES_LIST,
  SET_RECENTLY_USED_TAGS,
  SET_COMPLETED_CAMPAIGNS_RECORDS_WITHOUT_STATS,
  SET_TARGETS_WITH_NO_STATS,
  SET_PING_TREE_TARGETS_WITH_NO_STATS,
  SET_AFFILIATES,
  SET_BUYERS,
  SET_CURRENT_ACCOUNT_USER_GROUPS,
  SET_CALL_PLANS
} from './mutationTypes';

import {
  GET_CALL_PLANS
} from './actionTypes';

import {
  SET_ACTION_STATUS_PENDING,
  SET_ACTION_STATUS_SUCCESS,
  SET_ACTION_STATUS_ERROR
} from './helpers';

const RECENTLY_USED_TAGS_LIMIT = 10;

const actions = {
  getTimezones({ commit }) {
    infoService.getTimeZones().then((response) => {
      commit(SET_TIMEZONES_LIST, response.data);
    });
  },

  async getRecentlyUsedTags({ commit }, formName) {
    const userSettings = await userSettingsService.getUserSettings();
    const recentlyUsedTags =
      (userSettings[formName] && userSettings[formName].recentlyUsedTags) || [];

    commit(SET_RECENTLY_USED_TAGS, { formName, recentlyUsedTags });
  },

  async setRecentlyUsedTags({ commit }, { formName, tag }) {
    const userSettings = await userSettingsService.getUserSettings();

    userSettings[formName] = userSettings[formName] || {};
    let recentlyUsedTags = userSettings[formName].recentlyUsedTags || [];

    recentlyUsedTags = recentlyUsedTags.filter((findTag) => {
      return findTag.tagType !== tag.tagType && findTag.tagName !== tag.tagName;
    });
    recentlyUsedTags.unshift(tag);

    recentlyUsedTags.length =
      recentlyUsedTags.length > RECENTLY_USED_TAGS_LIMIT
        ? RECENTLY_USED_TAGS_LIMIT
        : recentlyUsedTags.length;

    userSettings[formName].recentlyUsedTags = recentlyUsedTags;

    try {
      userSettingsService.saveUserSettings(userSettings);
    } catch (e) {
      //
    }

    commit(SET_RECENTLY_USED_TAGS, { formName, recentlyUsedTags });
  },

  async getCompletedCampaignsWithNoStats({ commit, rootState }) {
    const campaigns = await campaignService.getBasicCompletedCampaigns(
      rootState.currentAccountId
    );

    commit(SET_COMPLETED_CAMPAIGNS_RECORDS_WITHOUT_STATS, campaigns);
  },

  async getAllTargets({ dispatch }) {
    dispatch('getTargetsWithNoStats');
    dispatch('getPingTreeTargetsWithNoStats');
  },

  async getTargetsWithNoStats({ commit, state }) {
    if (!state.targetsWithoutStats?.length) {
      const response = await targetService.getCachedTargets(state.currentAccountId);
      commit(SET_TARGETS_WITH_NO_STATS, response.data.targets);
    }
  },

  async getPingTreeTargetsWithNoStats({ commit, state }) {
    if (!state.pingTreeTargetsWithoutStats?.length) {
      const response = await pingTreeTargetService.getCachedTargets(state.currentAccountId);
      commit(SET_PING_TREE_TARGETS_WITH_NO_STATS, response.data.pingTreeTargets);
    }
  },

  async getAffiliates({ commit, state }, getStats) {
    if (!state.affiliates?.length) {
      const response = await affiliateService.getCachedAffiliates(state.currentAccountId, getStats);

      commit(SET_AFFILIATES, sortBy(response.data.affiliates, a => a.name.toLowerCase()));
    }
  },

  async getBuyers({ commit, state }, getStats) {
    if (!state.buyers?.length) {
      const response = await buyerService.getBuyers(state.currentAccountId, getStats);

      commit(SET_BUYERS, sortBy(response.data.buyers, b => b.name.toLowerCase()));
    }
  },

  async getGroupsForUser({ commit, state, getters }) {
    if ((getters.isPublisherGroupUser || getters.isBuyerGroupUser) && !state.currentAccountUserGroups?.length) {
      const response = await userGroupService.getGroupsForUser(state.currentAccountId);

      commit(SET_CURRENT_ACCOUNT_USER_GROUPS, sortBy(response.data.managers, m => m.name.toLowerCase()));
    }
  },

  async getCallPlans({ commit, state }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_CALL_PLANS });
    try {
      const response = await callPlanService.getCallPlansBasic(state.currentAccountId);
      commit(SET_CALL_PLANS, sortBy(response, cp => cp.name?.toLowerCase()));
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_CALL_PLANS });
    } catch (e) {
      console.error(e);
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_CALL_PLANS, error: e });
    }
    
  },
};

export default actions;
